const e = {
  1: "title-level-1",
  2: "title-level-2",
  3: "title-level-3",
  4: "title-level-4",
  5: "title-level-5",
  6: "title-level-6",
  p: "txt-paragraph",
  none: void 0
};
export {
  e as titleLvlMap
};
